import { useEffect, useState } from "react";
import { NavDropdown } from "react-bootstrap";
import Grid from "../../../components/grid";
import { Loader } from "../../../components/Loader";
import OffCanvas from "../../../components/offCanvas";
import { AddAllergy } from "./AddAllergy";

import { ReactComponent as EditIcon } from "../../../assets/img/EditTask.svg";
import Toaster, { ToastConfig } from "../../../components/Toaster";
import { ErrorTypes } from "../../../interfaces/errors";
import { createPatientApi } from "../../../api-helpers/PatientApiHelper";
import {
  FilterCriteria,
  GetPatientAllergies,
  GridDataRequest,
  GridDataResponse,
  PatientPersonalInfo,
} from "patients-experience-client";
import { AllergyHeader } from "./AllergyHeader";
import { ColDef } from "ag-grid-community";
import { DataProvider } from "../../../grid/GridDataAdaptor";
import { GenericGrid } from "../../../grid/GenericGrid";
import Lookups from "../../../constants/Lookups";
import { formatDate, formatDateTask } from "../../../helper/dateFormatter";
import { LookupCellValueGetter } from "../../../grid/renderers/LookupCellValueGetter";
import { createGridApi } from "../../../api-helpers/GridApiHelper";

interface AllergyProps {
  patientId: string;
}

export const Allergies = (props: AllergyProps) => {
  const [selectedAllergy, setSelectedAllergy] = useState(
    {} as GetPatientAllergies,
  );
  const [offCanvasTitle, setOffCanvasTitle] = useState("");
  const [offCanvasShow, setOffCanvasShow] = useState(false);
  const [offCanvasComp, setOffCanvasComp] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [gridReloadKey, setGridReloadKey] = useState(0);
  const [filters, setFilters] = useState<FilterCriteria[]>([]);
  const [toastConfig, setToastConfig] = useState<ToastConfig>({
    type: "success" as ErrorTypes,
    title: "",
    icon: "",
  });

  // APIs
  const patientApi = createPatientApi();
  const gridApi = createGridApi();

  const loadData = async (
    request: GridDataRequest,
  ): Promise<GridDataResponse> => {
    return (await gridApi.gridControllerGetAllergyGridData(request)).data;
  };

  const reloadGrid = () => {
    setGridReloadKey(gridReloadKey + 1);
  };

  const EditButton = (props: any) => {
    const handleClick = (allergy: GetPatientAllergies) => {
      setSelectedAllergy(allergy);
      handleOffCanvasShow("editAllergy");
    };
    return (
      <div
        className="d-flex align-items-center justify-content-center w-100 h-100"
        role="button"
        onClick={() => handleClick(props.data)}
      >
        <EditIcon />
      </div>
    );
  };

  const colDefs: ColDef[] = [
    {
      field: "allergy",
      headerName: "Allergy Name",
      pinned: "left",
      flex: 3,
      minWidth: 400,
      sortable: true,
    },
    {
      field: "typeName",
      headerName: "Type",
      minWidth: 100,
      // valueGetter: (params: any) => LookupCellValueGetter(Lookups.ALLERGY_TYPE, params),
      sortable: true,
    },
    {
      field: "categoryName",
      headerName: "Category",
      minWidth: 150,
      // valueGetter: (params: any) => LookupCellValueGetter(Lookups.ALLERGY_CATEGORY, params),
      sortable: true,
    },
    {
      field: "statusName",
      headerName: "Status",
      minWidth: 150,
      sortable: true,
      cellRenderer: (params: any) => {
        const status = params.value;
        if (status === "Active") {
          return <span className="badge background-completed">{status}</span>;
        }
        if (status === "Inactive") {
          return <span className="badge background-cancelled">{status}</span>;
        }

        if (status === "Resolved") {
          return <span className="badge background-planned">{status}</span>;
        }
        return <span className="">{"-"}</span>;
      },
    },
    {
      field: "knownSince",
      headerName: "Allergenic Since",
      minWidth: 140,
      sortable: true,
      valueFormatter: function (params: any) {
        return formatDateTask(params.data.knownSince); // Formats the date only
      },
    },
    {
      field: "severityOfReactionName",
      headerName: "Severity",
      minWidth: 200,
      sortable: true,
      // valueGetter: (params: any) => LookupCellValueGetter(Lookups.SEVERITY_LEVEL, params),
    },
    {
      cellRenderer: EditButton,
      maxWidth: 50,
      pinned: "right",
      sortable: false,
    },
  ];
  const handleOffCanvasShow = (comp: string) => {
    if (comp === "addAllergy") {
      setOffCanvasTitle("Add Allergy");
    }
    if (comp === "editAllergy") {
      setOffCanvasTitle("Edit Allergy");
    }

    setOffCanvasComp(comp);
    setOffCanvasShow(!offCanvasShow);
  };

  const handleAddUpdateAllergyForm = async (toasterConfig: ToastConfig) => {
    setToastConfig(toasterConfig);
    setShowToast(true);
  };

  return (
    <>
      <div className="row">
        <Toaster
          show={showToast}
          onClose={() => setShowToast(false)}
          type={toastConfig.type}
          title={toastConfig.title}
          message={toastConfig.message}
          icon={toastConfig.icon}
        />
      </div>
      {/* <AllergyHeader
        handleOffCanvasShow={handleOffCanvasShow}
      /> */}
      <AllergyHeader
        patientId={props.patientId}
        offCanvasShowCallback={handleOffCanvasShow}
        onUpdateFilters={setFilters}
      />
      <div className="medication-table">
        <GenericGrid
          gridId="allergies-grid"
          colDefs={colDefs}
          dataProvider={loadData}
          filters={filters}
          fixedHeight="350px"
          key={gridReloadKey}
          pagination={false}
        ></GenericGrid>
      </div>
      <OffCanvas
        title={offCanvasTitle}
        offCanvasShow={offCanvasShow}
        setOffCanvasShow={setOffCanvasShow}
        offCanvasComp={offCanvasComp}
      >
        {offCanvasComp === "addAllergy" && (
          <AddAllergy
            onSubmitAllergy={handleAddUpdateAllergyForm}
            setOffCanvasShow={setOffCanvasShow}
            patientId={props.patientId}
            reloadGrid={reloadGrid}
          />
        )}

        {offCanvasComp === "editAllergy" && (
          // <EditAllergy setOffCanvasShow={setOffCanvasShow} selectedAllergy={selectedAllergy} />
          <AddAllergy
            onSubmitAllergy={handleAddUpdateAllergyForm}
            setOffCanvasShow={setOffCanvasShow}
            patientId={props.patientId}
            reloadGrid={reloadGrid}
            selectedAllergy={selectedAllergy}
          />
        )}
      </OffCanvas>
    </>
  );
};
